import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";

import {
    MDBAutocomplete,
    MDBBtn,
    MDBCheckbox,
    MDBRadio,
    MDBSelect,
    MDBSpinner
} from "mdb-react-ui-kit";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router";

import { LocAddressSeach, addLocation, getAddLocationMisc } from '../../../apiclients/streamsapi_bridge';
import LocWeeklySchedule from '../../../components/editviews/location/LocWeeklySchedule';
import { getGlobalLocation } from '../../LoginNext';
import { formattedNumber, validatePhoneNumber } from '../phonenumbers/AddRemoveNumbers';
import { isFiveNineAccount } from '../../Login';
import SeatLimitAlert from '../../../apiclients/SeatLimitAlert';
import { CANADA, USA } from '../../../components/images';
const AddLocations = forwardRef(({ onClose, setIsloading, allLocation }, ref) => {
    const [dedicatedNineOneNumbers, setDedicatedNineOneNumbers] = useState([]);
    const [billingGroups, setBillingGroups] = useState([]);
    const [locationsList, setLocationsList] = useState([]);
    const { t, i18n } = useTranslation();
    const [addressReasults, setAddressReasults] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [isFiveNineAcc, setisFiveNineAcc] = useState(false);
    const [showWarning, setShowWarning] = useState(false);
    const warningToggle = () => setShowWarning(!showWarning);
    const [Warningalert, setWarningalert] = useState("");

    // const [isloading, setIsloading] = useState(false);
    // const [addressValue, setaddressValue] = useState("");

    const { register, handleSubmit, setValue, getValues, setError, formState: { isDirty, dirtyFields, errors }, clearErrors, watch, control } = useForm({
        defaultValues: {
            location_name: "",
            street_addr1: "",
            street_addr2: "",
            city: "",   //parseInt is used to convert the resulting string into an integer. The second argument 10 specifies the base (decimal) for parsing the string.-Ganesh
            state: 0,
            zip: "",
            primary_contact: {
                fname: "",
                lname: "",
                email: "",
                number: ""
            },
            nine_one_one: {
                same_as_primary_contact: true,
                enable_nine_one_one: true,
                fname: "",
                lname: "",
                email: "",
                number: "",
                dedicated_nine_one_one_number: "",
                specific_location: "",
            },
            schedule: {
                all_time: true,
                weekly_schedule: {
                    sun: {
                        selected: false,
                        from_time: "08:00 AM",
                        to_time: "05:00 PM",
                        twenty_four: false,
                    },
                    mon: {
                        selected: true,
                        from_time: "08:00 AM",
                        to_time: "05:00 PM",
                        twenty_four: false,
                    },
                    tue: {
                        selected: true,
                        from_time: "08:00 AM",
                        to_time: "05:00 PM",
                        twenty_four: false,
                    },
                    wed: {
                        selected: true,
                        from_time: "08:00 AM",
                        to_time: "05:00 PM",
                        twenty_four: false,
                    },
                    thu: {
                        selected: true,
                        from_time: "08:00 AM",
                        to_time: "05:00 PM",
                        twenty_four: false,
                    },
                    fri: {
                        selected: true,
                        from_time: "08:00 AM",
                        to_time: "05:00 PM",
                        twenty_four: false,
                    },
                    sat: {
                        selected: false,
                        from_time: "08:00 AM",
                        to_time: "05:00 PM",
                        twenty_four: false,
                    },
                },
            },
            invoice_this_location: true,
            billing_grp: 0,
        }
    });
    const weeklyFields = [
        {
            fieldLabel: t("sunday"),
            fieldValue: "sun",
        },
        {
            fieldLabel: t("monday"),
            fieldValue: "mon",
        },
        {
            fieldLabel: t("tuesday"),
            fieldValue: "tue",
        },
        {
            fieldLabel: t("wednesday"),
            fieldValue: "wed",
        },
        {
            fieldLabel: t("thursday"),
            fieldValue: "thu",
        },
        {
            fieldLabel: t("friday"),
            fieldValue: "fri",
        },
        {
            fieldLabel: t("saturday"),
            fieldValue: "sat",
        },
    ];
    const navigate = useNavigate();


    async function fetchAddLocationMisk() {
        try {
            let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            const params = {
                "misc": [
                    "add_location"
                ],
            };

            const serverResponse = await getAddLocationMisc(params, siteid);
            if (!serverResponse.ok) {
                console.log("Network response was not ok");
                throw new Error('Network response was not ok');
            }
            else {
                const responseData = await serverResponse.json();
                console.log("Response Data:", JSON.stringify(responseData));
                setDedicatedNineOneNumbers(responseData.misc.add_location.dedicated_nine_one_one_number || {});
                const transformedBillingGroups = (responseData.misc.add_location.billing_grp || []).map(entry => ({ text: entry.groupname, value: entry.groupid }));
                setBillingGroups(transformedBillingGroups);
                setStateList(responseData.misc.add_location.state || []);
                const transformedLocationsList = (responseData.misc.add_location.state || []).map(locations => ({ text: locations.statename, value: locations.stateid }));
                setLocationsList(transformedLocationsList);
            }

        } catch (error) {
            console.error("[fetchAddLocationMisk] Error:", error);
            // Handle the error, show a user-friendly message or log it.
        }
    }

    useEffect(() => {
        setisFiveNineAcc(isFiveNineAccount())
        if (isFiveNineAccount()) {
            setValue("nine_one_one.enable_nine_one_one", false, { shouldDirty: true })
        }
        fetchAddLocationMisk();
    }, []);  // Add any dependencies if needed






    const onsubmit = async (data) => {
        console.log("Preparing form data " + data);
        if (isDirty) {
            if (parseInt(data.billing_grp) === 0 && !data.invoice_this_location) {
                setError("billing_grp", {
                    message: "Please Select the Billing Group",
                });
                return;
            }
            if (parseInt(data.nine_one_one.dedicated_nine_one_one_number) === -1) {
                setError("nine_one_one.dedicated_nine_one_one_number", {
                    message: "--Select a Dedicated number for 911--",
                });
                return;
            }
            if (data.street_addr1 === "") {
                setError("street_addr1", {
                    message: "Street Address is required",
                });
                return;
            }
            var formData = {
                reqid: 31,
                location_name: data.location_name,
                street_addr1: data.street_addr1,
                street_addr2: data.street_addr2,
                city: data.city,
                state: parseInt(data.state),
                zip: data.zip,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                primary_contact: {
                    fname: data.primary_contact.fname,
                    lname: data.primary_contact.lname,
                    email: data.primary_contact.email,
                    number: data.primary_contact.number,
                },
                nine_one_one: {
                    enable_nine_one_one: data.nine_one_one.enable_nine_one_one,
                },
                schedule: {
                    all_time: data.schedule.all_time,
                }


            };

            if (data.nine_one_one.enable_nine_one_one) {
                formData.nine_one_one.same_as_primary_contact = data.nine_one_one.same_as_primary_contact;
                formData.nine_one_one.dedicated_nine_one_one_number = data.nine_one_one.dedicated_nine_one_one_number;
                formData.nine_one_one.specific_location = data.nine_one_one.specific_location;
            }

            if (!data.nine_one_one.same_as_primary_contact && data.nine_one_one.enable_nine_one_one) {
                formData.nine_one_one.fname = data.nine_one_one.fname;
                formData.nine_one_one.lname = data.nine_one_one.lname;
                formData.nine_one_one.email = data.nine_one_one.email;
                formData.nine_one_one.number = data.nine_one_one.number;
            }

            if (!data.schedule.all_time) {
                formData.schedule = {
                    weekly_schedule: displayWeeklyFields(data)
                }
            }
            if (data.invoice_this_location) {
                formData.invoice_this_location = data.invoice_this_location;
            } else {
                formData.billing_grp = parseInt(data.billing_grp);
            }

            console.log("formData :::::::::: ", formData);
            console.log("Add Location request Data :::::::::", JSON.stringify(formData));
            //alert(JSON.stringify(formData));
        }
        setIsloading(true);
        
        const saverep = await addLocation(formData, data.country);
        setIsloading(false);
        console.log(`reponse of add user :::: ${JSON.stringify(saverep)}`);
        let saverepeMsg = await saverep.json();
        console.log(`reponse of add user after:::: ${JSON.stringify(saverepeMsg)}`);
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            localStorage.setItem("s_message", saverepeMsg.message);
            await getGlobalLocation();
            // navigate("/LocLanding", {
            //     state: { tab: "location" },
            // });
            if (allLocation) {
                window.location.href = "/LocLanding";
            } else {
                navigate("/LocLanding", {
                    state: { tab: "location", tab1: "tab2" },
                });
                window.location.reload();
            }
            onClose();
        } else {
            if (saverepeMsg.message?.errors) {
                saverepeMsg.message.errors.forEach((err) => {
                    setError(err.param_name, {
                        type: "server",
                        message: err.message,
                    });
                    const fieldElement = document.querySelector(
                        `input[name="${err.param_name}"]`
                    );
                    if (fieldElement) {
                        fieldElement.focus();
                        fieldElement.scrollIntoView({ behavior: "smooth" });
                    }
                });
            } else {
                if (saverepeMsg.nineoo_profile_limit_exceed && saverepeMsg.nineoo_profile_limit_exceed !== "") {
                    setWarningalert(saverepeMsg.nineoo_profile_limit_exceed);
                    setShowWarning(true);
                }
            }
        }
    }

    function displayWeeklyFields(data) {
        let weeklyData = {};
        weeklyFields && weeklyFields.map((item) => {
            const fieldName = item.fieldValue;
            if (!weeklyData[fieldName]) {
                weeklyData[fieldName] = {}; // Initialize if not already present
            }
            weeklyData[fieldName].selected = data.schedule.weekly_schedule[fieldName].selected;
            if (data.schedule.weekly_schedule[fieldName].selected) {
                weeklyData[fieldName].from_time = data.schedule.weekly_schedule[fieldName].from_time;
                weeklyData[fieldName].to_time = data.schedule.weekly_schedule[fieldName].to_time;
                weeklyData[fieldName].twenty_four = data.schedule.weekly_schedule[fieldName].twenty_four;
            }
        });
        return weeklyData;
    }
    const [typingTimeout, setTypingTimeout] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isDisplay, setisDisplay] = useState(false);
    const allowAPI = useRef(true);

    useEffect(() => {
        // Cleanup function to clear timeout when component unmounts or input value changes
        return () => {
            if (typingTimeout) {
                clearTimeout(typingTimeout);
            }
        };
    }, [typingTimeout]);

    function handleSearchAddressChange(searchValue) {
        try {
            if (watch("street_addr1") !== searchValue) {
                clearErrors("street_addr1");
            }
            setValue("street_addr1", searchValue, { shouldDirty: true });
            if (typingTimeout) {
                clearTimeout(typingTimeout);
            }
            const newTimeout = setTimeout(() => {
                sendApIRequest(searchValue);
            }, 500);
            // Update the typingTimeout state with the new timeout
            setTypingTimeout(newTimeout);


        } catch (error) {
            console.log(`Error in handleSearchAddressChange :::: ${error}`);

        }
    }

    const sendApIRequest = async (searchValue) => {
        try {
            if (searchValue.trim() !== "" && allowAPI.current) {
                //if (searchValue.trim() !== "") {
                let update = {
                    reqid: 84,
                    search: searchValue,
                    siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                }
                setIsLoading(true);
                console.log("Request for the search :::::: " + JSON.stringify(update));
                const serverResponse = await LocAddressSeach(update);
                setIsLoading(false);
                if (!serverResponse.ok) {
                    console.log("Network response was not ok");
                    throw new Error('Network response was not ok');
                }
                else {
                    const responseData = await serverResponse.json();
                    console.log("Response Data:", JSON.stringify(responseData));
                    let addressList = responseData?.message?.suggestions ?? [];
                    setAddressReasults(addressList);
                    if (addressList.length === 0) {
                        setisDisplay(false);
                    } else {
                        setisDisplay(true);
                    }
                }

            } else {
                allowAPI.current = true;
                setisDisplay(false);
            }



        } catch (error) {
            console.log(`Error in sendApIRequest for address search :::: ${error}`);

        }

    }

    function handleAddressSelect(address) {

        if(address.country) {
            setValue("country", address.country, { shouldDirty: true });
        }
        if (address.street_line) {
            // setaddressValue(address.street_line);
            setValue("street_addr1", address.street_line, { shouldDirty: true });
        }
        if (address.secondary != undefined) {
            setValue("street_addr2", address.secondary, { shouldDirty: true });
        } else {
            setValue("street_addr2", "", { shouldDirty: true });

        }
        if (address.city) {
            setValue("city", address.city, { shouldDirty: true });
            clearErrors("city");
        }
        if (address.state) {
            const stateObj = stateList.find((state) => state.statecode.trim() === address.state.trim());
            console.log("stateObj :::::::: " + JSON.stringify(stateObj));
            if (stateObj) {
                setValue("state", stateObj.stateid, { shouldDirty: true });
                clearErrors("state");
            }
        }

        if (address.zipcode) {
            setValue("zip", address.zipcode, { shouldDirty: true });
            clearErrors("zip");
        }


    }

    const handleFocus = (event) => {
        if (event.target.value != "") {
            event.target.select();
        }
    };

    useEffect(() => {
        if (errors.street_addr1 || errors.state) {
            // debugger
            let input = null;
            if (errors.street_addr1) {
                input = document.getElementById(`street_addr1`);

            }
            if (errors.state) {
                input = document.getElementById(`state`);

            }
            if (input) {
                input.focus();
                input.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }, [errors.street_addr1, errors.state]);

    const handleOk = () => {
        setValue("nine_one_one.enable_nine_one_one", false, { shouldDirty: true });
        warningToggle();
    }

    return (
        <>
            <div>
                <form>
                    <div className="tel-numbers">{t("name")} *</div>
                    <div className="form pt-1">
                        <input
                            type="text" maxLength={50}
                            className="form-control"
                            id="location_name"
                            {...register("location_name", {
                                required: "Name is required"
                            })}
                        />
                        {errors.location_name && (
                            <p className="text-danger">{errors.location_name.message}</p>
                        )}
                    </div>
                    <div className="tel-numbers mt-4">{t("StreetAddress")} * </div>
                    <div className="form pt-1">
                        <Controller
                            name="street_addr1"
                            control={control}
                            rules={{ required: "Street Address 1 is required" }}

                            render={({ field }) => (
                                <MDBAutocomplete
                                    data={addressReasults}
                                    id='street_addr1'
                                    value={field.value}
                                    displayValue={(address) => address.street_line}
                                    isLoading={isLoading}
                                    // open={isDisplay}
                                    placeholder='Address 1'
                                    onSearch={handleSearchAddressChange}
                                    onSelect={(e) => {
                                        allowAPI.current = false;
                                        setisDisplay(false);
                                    }}
                                    onChange={(val) => field.onChange(val)}
                                    itemContent={(address) => (
                                        <div
                                            onClick={(e) => {
                                                e.preventDefault();
                                                allowAPI.current = false;
                                                handleAddressSelect(address);
                                                field.onChange(address.street_line); // update value
                                            }}
                                        >
                                            {address.country &&
                                                <img src={address.country === "USA" ? USA : CANADA} className='me-3' width={25} />
                                             } 
                                            {address.street_line || ""}
                                            {address.secondary ? ", " + address.secondary : ""}
                                            {address.city ? ", " + address.city : ""}
                                            {address.state ? ", " + address.state : ""}
                                            {address.zipcode ? ", " + address.zipcode : ""}
                                        </div>
                                    )}
                                />
                            )}
                        />
                        {errors?.street_addr1 && (
                            <p className="text-danger">{errors?.street_addr1?.message}</p>
                        )}
                    </div>
                    <div className="form pt-1">
                        <input
                            type="text" placeholder='Address 2'
                            id='street_addr2'
                            className="form-control w-100"
                            {...register("street_addr2")}
                        />
                        {errors.street_addr2 && (
                            <p className="text-danger">{errors.street_addr2.message}</p>
                        )}
                    </div>
                    <div className="tel-numbers mt-4">{t("City")} *</div>
                    <div className="form pt-1">
                        <input
                            type="text"
                            className="form-control w-100"
                            id='city'
                            {...register("city", {
                                required: "City is required"
                            })}
                        />
                        {errors.city && (
                            <p className="text-danger">{errors.city.message}</p>
                        )}
                    </div>
                    <div className="row mt-4">
                        <div className="col-6">
                            <div className="tel-numbers">{t("State")} * </div>
                            <div className="form">
                                <Controller
                                    name="state"
                                    control={control}
                                    rules={{
                                        validate: (value) => value !== 0 || "State is required"
                                    }}
                                    render={({ field }) => (
                                        <MDBSelect
                                            id='state'
                                            data={[{ text: "-- Select State --", value: 0 }, ...locationsList]}
                                            value={field.value}
                                            search
                                            onChange={(e) => {
                                                field.onChange(e.value);
                                            }}
                                        />
                                    )}
                                />
                                {errors.state && (
                                    <p className="text-danger">{errors.state.message}</p>
                                )}
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="tel-numbers">{t("ZIPCode")} *</div>
                            <div className="form">
                                <input
                                    type="text"
                                    id='zip'
                                    className="w-100"
                                    onKeyPress={(event) => {
                                        if (!/[0-9 ]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    {...register("zip", {
                                        required: "ZIP Code is required",
                                        setValueAs: (v) => v?.trim(),
                                    })}
                                />
                                {errors.zip && (
                                    <p className="text-danger">{errors.zip.message}</p>
                                )}

                            </div>
                        </div>
                    </div>
                    <div className="tel-numbers mt-5">
                        <strong>{t("PrimaryContact")}</strong>
                    </div>
                    <div className="row mt-4">
                        <div className="col-6">
                            <div className="tel-numbers fw-500">
                                {t("firstName")} *
                            </div>
                            <div className="form">
                                <input
                                    type="text"
                                    maxLength={30}
                                    id='primary_contact.fname'
                                    className="w-100"
                                    {...register("primary_contact.fname", {
                                        required: "First Name is required"
                                    })}
                                />
                                {errors?.primary_contact?.fname && (
                                    <p className="text-danger">{errors?.primary_contact?.fname.message}</p>
                                )}
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="tel-numbers fw-500">
                                {t("lastName")} *
                            </div>
                            <div className="form">
                                <input
                                    id='primary_contact.lname'
                                    type="text"
                                    maxLength={20}
                                    className="w-100"
                                    {...register("primary_contact.lname", {
                                        required: "Last Name is required"
                                    })}
                                />
                                {errors?.primary_contact?.lname && (
                                    <p className="text-danger">{errors.primary_contact.lname.message}</p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="tel-numbers mt-4"> {t("email")} * </div>
                    <div className="form pt-1">
                        <input
                            type="text"
                            className="form-control w-100"
                            id='primary_contact.email'
                            {...register("primary_contact.email", {
                                 setValueAs: (value) => value?.trim(),
                                required: "Email is required", pattern: {
                                    value: /^[_A-Za-z0-9-]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,})$/i,
                                    message: "invalid email",
                                },
                            })}
                        />
                        {errors?.primary_contact?.email && (
                            <p className="text-danger">{errors.primary_contact.email.message}</p>
                        )}
                    </div>
                    <div className="tel-numbers mt-4">{t("Number")} *</div>
                    <div className="form pt-1">
                        <input
                            type="text"
                            className="form-control w-100"
                            id='primary_contact.number'
                            {...register("primary_contact.number", {
                                required: "Number is required", validate: validatePhoneNumber,
                            })}
                        />
                        {errors?.primary_contact?.number && (
                            <p className="text-danger">{errors.primary_contact.number.message}</p>
                        )}
                    </div>
                    {/* <div className="routing-border mt-2"> </div> */}


                    {!isFiveNineAcc && (
                        <>
                            <div className="tel-numbers mt-5">
                                <strong>{t("911Information")}</strong>
                            </div>
                            <div className="add-numbermain mt-3">
                                <div>
                                    <div className="tel-numbers">
                                        {t("en911services")}
                                    </div>
                                </div>
                                <div className="phoneselect">
                                    <label className="switch">
                                        <input className="form-control" type="checkbox" name="enableLocation" id='nine_one_one.enable_nine_one_one' checked={getValues("nine_one_one.enable_nine_one_one")} onChange={(e) => setValue("nine_one_one.enable_nine_one_one", e.target.checked, { shouldDirty: true })} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                            {getValues("nine_one_one.enable_nine_one_one") && (
                                <div className="add-numbermain mt-3">
                                    <div>
                                        <div className="tel-numbers">
                                            {t("UsePrimaryCont")}
                                        </div>
                                    </div>
                                    {/* {!dedenableDisableServiceLocationecatedNo && ( */}
                                    <div className="phoneselect">
                                        <label className="switch">
                                            <input className="form-control" type="checkbox" name="emergtxt" id='nine_one_one.same_as_primary_contact' checked={getValues("nine_one_one.same_as_primary_contact")} onChange={(e) => setValue("nine_one_one.same_as_primary_contact", e.target.checked, { shouldDirty: true })} />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>


                                </div>
                            )}
                            {!getValues("nine_one_one.same_as_primary_contact") && getValues("nine_one_one.enable_nine_one_one") && (
                                <div>
                                    <div className="row mt-4">
                                        <div className="col-6">
                                            <div className="tel-numbers">
                                                {t("firstName")}
                                            </div>
                                            <div className="form">
                                                <input
                                                    type="text"
                                                    maxLength={30}
                                                    className="w-100"
                                                    id='nine_one_one.fname'
                                                    {...register("nine_one_one.fname", {
                                                        required: "First name is required"
                                                    })}
                                                />
                                                {errors?.nine_one_one?.fname && (
                                                    <p className="text-danger">{errors.nine_one_one.fname.message}</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="tel-numbers">
                                                {t("lastName")}
                                            </div>
                                            <div className="form">
                                                <input
                                                    type="text"
                                                    maxLength={20}
                                                    className="w-100"
                                                    id='nine_one_one.lname'
                                                    {...register("nine_one_one.lname", {
                                                        required: "Last name is required"
                                                    })}

                                                />
                                                {errors?.nine_one_one?.lname && (
                                                    <p className="text-danger">{errors.nine_one_one.lname.message}</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tel-numbers mt-4">{t("Contact Email Address")}</div>
                                    <div className="form pt-1">
                                        <input
                                            type="text"
                                            className="form-control w-100"
                                            id='nine_one_one.email'
                                            {...register("nine_one_one.email", {
                                                setValueAs: (v) => v?.trim(), 
                                                required: "Email is required", pattern: {
                                                    value: /^[_A-Za-z0-9-]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,})$/i,
                                                    message: "invalid Email",
                                                },
                                            })}
                                        />
                                        {errors?.nine_one_one?.email && (
                                            <p className="text-danger">{errors.nine_one_one.email.message}</p>
                                        )}
                                    </div>
                                    <div className="tel-numbers mt-4">{t("Contact Number")}</div>
                                    <div className="form pt-1">
                                        <input
                                            type="text"
                                            className="form-control w-100"
                                            id='nine_one_one.number'
                                            {...register("nine_one_one.number", {
                                                required: "911 Number is required"
                                                , validate: validatePhoneNumber,
                                            })}
                                        />
                                        {errors?.nine_one_one?.number && (
                                            <p className="text-danger">{errors.nine_one_one.number.message}</p>
                                        )}
                                    </div>
                                </div>
                            )}

                            {getValues("nine_one_one.enable_nine_one_one") && (
                                <div>
                                    <div className="tel-numbers mt-4">
                                        {t("emerg911txt")} *
                                    </div>
                                    <select
                                        className="form-control form-select selectname w-100"
                                        id='nine_one_one.dedicated_nine_one_one_number'
                                        {...register("nine_one_one.dedicated_nine_one_one_number", {
                                            required: "Please select a Dedicated 911 Number",
                                            validate: (value) =>
                                                value !== "-1" || "Please select a Dedicated 911 Number"
                                        })}
                                        defaultValue="-1"
                                    >
                                        <option value="-1">--Select a Dedicated Number for 911--</option>
                                        {dedicatedNineOneNumbers &&
                                            Object.entries(dedicatedNineOneNumbers).map(([key, value]) => (
                                                <option key={key} value={key}>
                                                    {formattedNumber(value)}
                                                </option>
                                            ))}
                                    </select>

                                    {errors?.nine_one_one?.dedicated_nine_one_one_number && (
                                        <p className="text-danger">
                                            {errors.nine_one_one.dedicated_nine_one_one_number.message}
                                        </p>
                                    )}

                                    <div className="tel-numbers mt-4">
                                        {t("Speclocation")} *
                                    </div>
                                    <div className="form pt-1">
                                        <input
                                            type="text"
                                            id='nine_one_one.specific_location'
                                            className="form-control w-100"
                                            {...register("nine_one_one.specific_location", {
                                                required: "Specific Location is required"
                                            })}
                                        />
                                        {errors?.nine_one_one?.specific_location && (
                                            <p className="text-danger">{errors?.nine_one_one?.specific_location?.message}</p>
                                        )}
                                    </div>
                                </div>
                            )}
                        </>
                    )}



                    <div className="tel-numbers mt-5">
                        <strong>{t("weeklyschedule")}</strong>
                    </div>
                    <div className="mt-4">
                        <div className="d-flex">

                            <MDBRadio
                                name="inlineRadio"
                                id="inlineRadio1"
                                value={true}
                                label="24/7"
                                inline
                                checked={getValues("schedule.all_time")}
                                onChange={() => setValue("schedule.all_time", true, { shouldDirty: true })}
                            />
                            <MDBRadio
                                name="inlineRadio"
                                id="inlineRadio2"
                                value={false}
                                label="Weekly Schedule"
                                inline
                                Checked={!getValues("schedule.all_time")}
                                onChange={() => setValue("schedule.all_time", false, { shouldDirty: true })}
                            />

                        </div>
                        {!getValues("schedule.all_time") && (
                            <>
                                {weeklyFields.map((item) => (
                                    <LocWeeklySchedule
                                        register={register}
                                        getValues={getValues}
                                        setValue={setValue}
                                        checkedSelected={`schedule.weekly_schedule.${item.fieldValue}.selected`}
                                        twentyFourFlag={`schedule.weekly_schedule.${item.fieldValue}.twenty_four`}
                                        fromTime={`schedule.weekly_schedule.${item.fieldValue}.from_time`}
                                        toTime={`schedule.weekly_schedule.${item.fieldValue}.to_time`}
                                        fieldLabel={item.fieldLabel}
                                        watch={watch}
                                    />
                                ))}

                            </>
                        )}
                        <div className="tel-numbers mt-4">{t("billingGroup")}</div>
                        <div className="form mt-1 mb-3 d-flex w-100 justify-content-between align-items-center">
                            <div className="w-50">
                                <MDBSelect
                                    data={[{ text: "-- Select Billing Group --", value: 0 }, ...billingGroups]}
                                    defaultValue={getValues("billing_grp")}
                                    disabled={getValues("invoice_this_location")}
                                    search
                                    onChange={(e) => {
                                        clearErrors("billing_grp");
                                        setValue('billing_grp', e.value, { shouldDirty: true });
                                    }}
                                />
                                {errors.billing_grp && (
                                    <p className="text-danger">{errors.billing_grp.message}</p>
                                )}
                            </div>
                            <div>
                                <MDBCheckbox name='flexCheck' value='' id='inlineCheckbox1' label='Invoice this location'
                                    checked={getValues("invoice_this_location")}
                                    onChange={(e) => {
                                        // e.preventDefault();
                                        setValue("invoice_this_location", e.target.checked, { shouldDirty: true });
                                        clearErrors("billing_grp");

                                    }} />

                            </div>
                        </div>
                    </div>
                </form>
            </div >
            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => { e.preventDefault(); handleSubmit(onsubmit)() }}>
                    {t("add")}</button>
            </div>
            {showWarning && (
                <SeatLimitAlert
                    warningToggle={warningToggle}
                    setShowWarning={setShowWarning}
                    warningMessage={Warningalert}
                    onOk={handleOk}
                />
            )}
            {/* <MDBModalFooter>
                <MDBBtn onClick={(e) => onClose(e)} color="secondary">
                    {t("close")}
                </MDBBtn>
                <MDBBtn onClick={(e) => {
                    e.preventDefault();
                    handleSubmit(onsubmit)();
                }} color="primary">
                    {t("add")}
                </MDBBtn>

            </MDBModalFooter> */}

            {/* {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )} */}


        </>
    )
});

export default AddLocations